import { Heading5, Heading6 } from "components/text/heading/style";
import {
  DeleteModeloButton,
  DeleteModeloContent,
  DeleteModeloHeader,
  ModeloListErrorContent,
} from "./style";
import React from "react";
import billing_theme from "style/theme_colors";
import PrimaryButton from "components/button/billing_button";
import BillingIconSharp from "components/billing_icon/sharp_icon";
import { Body3 } from "components/text/body/style";

const ModeloDeleteContent: React.FC<{
  onDelete: () => void;
  onClose: () => void;
  onLoading: boolean;
}> = ({ onDelete, onClose, onLoading }) => {
  const close = () => {
    onClose();
  };
  return (
    <ModeloListErrorContent>
      <DeleteModeloHeader>
        <BillingIconSharp icon={"delete"} color={billing_theme.pallete.error.A100} size={32} />
        <BillingIconSharp
          icon={"close"}
          color={billing_theme.pallete.primary.A400}
          size={32}
          onTap={close}
        />
      </DeleteModeloHeader>
      <DeleteModeloContent>
        <Heading5 color={billing_theme.pallete.tertiary.A600} fontWeight={600}>
          Deseja excluir o modelo?
        </Heading5>
        <Body3 color={billing_theme.pallete.tertiary.A600} fontWeight={500}>
          Ao excluir essa fatura, os dados serão movidos para a lixeira e posteriormente poderá ser
          recuperado.
        </Body3>
      </DeleteModeloContent>
      <DeleteModeloButton>
        <PrimaryButton label={"Cancelar"} onTap={() => onClose()} isSmall disable={onLoading} />
        <PrimaryButton
          label={"Deletar mesmo assim"}
          onTap={() => onDelete()}
          isSmall
          disable={onLoading}
        />
      </DeleteModeloButton>
    </ModeloListErrorContent>
  );
};

export default ModeloDeleteContent;
